<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">

      <mat-form-field>
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.name" matInput name="name">
      </mat-form-field>

      <ac-input-container label="Routers"   >
        <ac-select
          [(acModel)]="search.routerIds"
          [items]="search.routingServers"
          [allowClear]="true"
          [multiple]="true"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

    </div>
  </div>
</arm-dialog>

